import dayjs from 'dayjs';

const compareDayAndMonthWithNow = cleave => {
  const dayAndMonthReminder = cleave.getFormattedValue();
  const dateThisYear = `${dayAndMonthReminder}/${dayjs().year()}`;
  const dateNextYear = `${dayAndMonthReminder}/${dayjs().year() + 1}`;
  const day = dayjs(dayjs(dayAndMonthReminder, 'DD/MM').format('YYYY/MM/DD'));
  const now = dayjs().hour(0).minute(0).second(0);
  return day.diff(now, 'day') >= 0 ? dateThisYear : dateNextYear;
};

export default compareDayAndMonthWithNow;
